import { render, staticRenderFns } from "./adminServiceDepartment.vue?vue&type=template&id=48b88c5c&scoped=true"
import script from "./adminServiceDepartment.vue?vue&type=script&lang=js"
export * from "./adminServiceDepartment.vue?vue&type=script&lang=js"
import style0 from "./adminServiceDepartment.vue?vue&type=style&index=0&id=48b88c5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b88c5c",
  null
  
)

export default component.exports